import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import {
  Button,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";

import toast from "react-hot-toast";
import Select from "react-select";
import DestinationWidgetService from "../../../services/KangarooServices/Intelligence/DestinationWidgetService";
import UniversityService from "../../../services/KangarooServices/UniversityService";
import WidgetService from "../../../services/KangarooServices/Intelligence/WidgetService";
import DestinationService from "../../../services/KangarooServices/DestinationService";

const DestinationWidgetForm = ({ isOpen, toggle, selectedItem, fetchData }) => {
  const [institutedata, setInstituteData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [widgetData, setWidgetData] = useState([]);
  const fetchWidgetData = async () => {
    try {
      const response = await WidgetService.getList();
      setWidgetData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchWidgetData();
  }, []);
  const formik = useFormik({
    initialValues: {
      destinationCountryIds: Array.isArray(selectedItem?.destinationCountryIds)
        ? selectedItem.destinationCountryIds.map(String)
        : [],
      widgetIds: Array.isArray(selectedItem?.widgetIds)
        ? selectedItem.widgetIds.map(String)
        : [],
    },
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      try {
        // Build payload

        if (values?.id) {
          await DestinationWidgetService.update(values?.id, values);
          toast.success("Form updated successfully");
        } else {
          await DestinationWidgetService.create(values);
          toast.success("Form created successfully");
        }
        resetForm();
        fetchData();
        toggle();
      } catch (error) {
        console.log(error);
        toast.error("Something went wrong!");
      }
    },
  });

  const fetchUniversityData = async () => {
    setLoading(true);
    try {
      const response = await DestinationService.getList();
      setInstituteData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUniversityData();
  }, []);

  const instituteOptions = institutedata.map((i) => ({
    value: String(i.id),
    label: i.name,
  }));

  const widgetOptions = widgetData?.map((type) => ({
    value: type.id,
    label: type.name,
  }));
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Assign institute</ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-3">
            <Label>Widget</Label>

            <Select
              isMulti
              options={widgetOptions}
              value={widgetOptions.filter((opt) =>
                formik.values.widgetIds.includes(opt.value),
              )}
              onChange={(selected) =>
                formik.setFieldValue(
                  "widgetIds",
                  selected ? selected.map((s) => s.value) : [],
                )
              }
              placeholder="Select widget"
            />
          </div>

          <div className="mb-3">
            <Label>Affiliate Insitute</Label>
            <Select
              isMulti
              options={instituteOptions}
              value={instituteOptions.filter((opt) =>
                formik.values.destinationCountryIds.includes(opt.value),
              )}
              onChange={(selected) =>
                formik.setFieldValue(
                  "destinationCountryIds",
                  selected ? selected.map((s) => s.value) : [],
                )
              }
              placeholder="Select affiliate institute"
            />
          </div>

          <div className="d-flex justify-content-end gap-3 mb-3">
            <button type="submit" className="btn btn-success">
              {selectedItem?.id ? "Update" : "Create"}
            </button>
            <button type="button" className="btn btn-danger" onClick={toggle}>
              Cancel
            </button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default DestinationWidgetForm;
